import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MessageCircle, Phone, CheckCircle2 } from 'lucide-react';
import { heroContent, companyInfo } from '../mockData';

const HeroSection = ({ onScrollToForm }) => {
  const handleWhatsAppClick = () => {
    // Facebook Pixel - Track Contact event
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Contact', {
        content_name: 'Hero WhatsApp Click',
        content_category: 'WhatsApp'
      });
    }
    const message = encodeURIComponent(
      'Assalamualaikum. Saya telah membuat semakan awal melalui website dan ingin mendapatkan maklumat lanjut.'
    );
    window.open(`https://wa.me/${companyInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-12 sm:py-20">
      {/* Background Video with Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster={heroContent.backgroundImage}
          className="w-full h-full object-cover"
        >
          <source src="/videos/facebook_ad_muhd_aiman.mp4" type="video/mp4" />
          {/* Fallback image if video fails */}
        </video>
        <img
          src={heroContent.backgroundImage}
          alt="Sarawak DUN Building"
          className="hidden"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/95 via-emerald-800/90 to-emerald-950/95"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-amber-600/10 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            {heroContent.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-xl lg:text-2xl text-emerald-50 mb-6 sm:mb-8 leading-relaxed max-w-3xl mx-auto">
            {heroContent.subheadline}
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-6 sm:mb-8">
            {heroContent.trustBadges.map((badge, index) => (
              <div
                key={index}
                className="flex items-center gap-1.5 bg-white/10 backdrop-blur-md px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-amber-400/30"
              >
                <CheckCircle2 className="h-4 w-4 text-amber-400 flex-shrink-0" />
                <span className="text-white text-xs sm:text-sm font-semibold">{badge}</span>
              </div>
            ))}
          </div>

          {/* Phone Number Display */}
          <a
            href={`tel:${companyInfo.phone}`}
            className="inline-flex items-center gap-2 sm:gap-3 bg-amber-500/20 backdrop-blur-md px-4 sm:px-6 py-2.5 sm:py-3 rounded-full border-2 border-amber-400 mb-6 sm:mb-8 hover:bg-amber-500/30 transition-all duration-300 hover:scale-105"
            data-testid="hero-phone-link"
          >
            <Phone className="h-5 w-5 text-amber-400" />
            <span className="text-amber-100 font-bold text-base sm:text-lg">{companyInfo.phoneFormatted}</span>
          </a>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-6 sm:mb-8">
            <Button
              size="lg"
              onClick={onScrollToForm}
              data-testid="hero-primary-cta"
              className="w-full sm:w-auto bg-amber-500 hover:bg-amber-600 text-emerald-950 font-bold text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 rounded-lg shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300 border-2 border-amber-400 animate-pulse-cta"
            >
              {heroContent.primaryCTA}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>

            <Button
              size="lg"
              onClick={handleWhatsAppClick}
              data-testid="hero-whatsapp-cta"
              variant="outline"
              className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white border-2 border-green-400 hover:border-green-300 font-semibold text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6 rounded-lg hover:scale-105 transition-all duration-300"
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              {heroContent.secondaryCTA}
            </Button>
          </div>

          {/* Trust Statement */}
          <div className="inline-block bg-white/10 backdrop-blur-md px-4 sm:px-6 py-2 sm:py-3 rounded-full border border-white/20">
            <p className="text-emerald-50 text-xs sm:text-sm font-medium">
              ✓ Dipercayai oleh pelanggan di seluruh Sarawak
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
